<template>
  <div
    id="player-controls"
    class="
      $color/background:gray:222
      color/background
      layout/flex
      layout/height:100%
      layout/justify:center
      layout/padding:page:0.5
      layout/relative
    "
    >
    <ul
      class="
        $layout/page:fixed
        layout/flex
        layout/grid:gap:page
        layout/height:100%
      "
      >
      <ControlButton
        v-if="isCurrentLast"
        ref="repeat"
        :initially-hidden="true"
        >
        <a :href="linkHref(firstTourStopId)">
          <Icon icon-name="24_ouroboros.svg" />
        </a>
      </ControlButton>

      <ControlButton
        :class="{ 'layout/opacity': !hasPreviousStop }"
        :style="{ '--layout--opacity': opacityInactive }"
        >
        <a
          v-if="hasPreviousStop"
          :href="linkHref(previousStopId)"
          data-gtm="playlist / prev"
          aria-label="Previous audio"
          >
          <IconArrow />
        </a>
        <IconArrow v-else />
      </ControlButton>

      <ControlButton>
        <button
          class=""
          :data-gtm="gtmPlayPause"
          :aria-label="ariaLabelPlayPause"
          :aria-controls="ariaControls"
          @click="toggleAudio"
          v-html="svgPlayPause"
        />
      </ControlButton>

      <ControlButton
        :class="{ 'layout/opacity': !hasNextStop }"
        :style="{ '--layout--opacity': opacityInactive }"
        >
        <a
          v-if="hasNextStop"
          :href="linkHref(nextStopId)"
          data-gtm="playlist / next"
          aria-label="Next audio"
          >
          <IconArrow :is-previous="false" />
        </a>
        <IconArrow
          v-else
          :is-previous="false"
        />
      </ControlButton>
    </ul>
  </div>
</template>

<script>
  import { embedSVG } from 'Helpers/embedSVG';
  import ControlButton from './control-button';
  import IconArrow from './icon-arrow';
  import Icon from '../icons/icon';

  export default {
    components: {
      ControlButton,
      IconArrow,
      Icon,
    },
    props: {
      ariaControls: { type: String, required: true },
      firstTourStopId: { type: Number, required: true },
      isCurrentLast: { type: Boolean, required: true },
      isPlaying: { type: Boolean, required: true },
      lastTourStopId: { type: Number, required: true },
      nextStopId: { type: Number, required: true },
      previousStopId: { type: Number, required: true },
      totalTourStopCount: { type: Number, required: true },
      tourId: { type: Number, required: true },
      tourStopId: { type: Number, required: true },
    },
    data: function() {
      return {
        embedSVG: embedSVG,
        opacityInactive: 16,
      };
    },
    computed: {
      hasPreviousStop() {
        return this.previousStopId !== 0;
      },
      hasNextStop() {
        return this.nextStopId !== 0;
      },
      ariaLabelPlayPause() {
        return this.isPlaying ? 'Pause audio' : 'Play audio';
      },
      gtmPlayPause() {
        return this.isPlaying ? 'playlist / pause' : 'playlist / play';
      },
      svgPlayPause() {
        const icon = this.isPlaying
          ? 'icon__audio_pause--52.svg'
          : 'icon__audio_play--52.svg';

        return embedSVG(icon, 'link/cursor');
      },
    },
    methods: {
      linkHref(stopId) {
        return `/audio/playlist/${this.tourId}/${stopId}`;
      },
      toggleAudio() {
        if (this.isPlaying) {
          this.$emit('pause');
        } else {
          this.$emit('play');
        }
      },
      showRepeat() {
        this.$refs.repeat.$el.classList.remove('layout/none');
        this.$refs.repeat.$el.classList.add('layout/flex');
      }
    }
  };
</script>
